import { IEmployeeLiquidator } from '@models/PayrollAdjuster';

export const hasEmployeeWithoutContractInRange = (
    employees: IEmployeeLiquidator[],
    startDate: string,
    finishDate: string
): boolean => {
    const validationActiveEmployeeWithContracts = employees.some(currentEmployee => {
        const employeeCurrentContract = currentEmployee.information.contract[0];
        const contractStartDate = employeeCurrentContract.start_date_contract_change || employeeCurrentContract.start_date;
        const contractFinishDate = employeeCurrentContract.finish_date;
        const finishDateValidation = contractFinishDate != null && contractFinishDate < startDate;
        if (contractStartDate > finishDate || finishDateValidation) return currentEmployee;
    });
    return validationActiveEmployeeWithContracts;
};
